"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppState = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const storage_1 = __importDefault(require("../helper/storage"));
const store_1 = require("../store");
const thunks_1 = require("../store/thunks");
const useAuth_1 = require("./useAuth");
const useDevice_1 = require("./useDevice");
const useAnalytics_1 = __importDefault(require("./useAnalytics"));
const useAppState = () => {
    const { trackUserSignOut } = (0, useAnalytics_1.default)();
    const [loader, setLoader] = (0, react_1.useState)(false);
    const dispatch = (0, store_1.useAppDispatch)();
    const { isTabOrDesktopDevice } = (0, useDevice_1.useDevice)();
    const conversation = (0, react_redux_1.useSelector)((state) => state.getUserOptions.conversation);
    const { auth, GoogleSignin, FirebaseAuthTypes } = (0, useAuth_1.useAuth)();
    const fbUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.fbUser);
    const setUserSession = async (userData) => {
        await storage_1.default.setItem("userSession", JSON.stringify(userData));
    };
    const clearUserSession = (0, react_1.useCallback)(async () => {
        // const removedUserSession = await StorageHelper.clear();
        // return removedUserSession;
    }, []);
    const signOutAppState = async () => {
        await dispatch((0, thunks_1.logOut)());
        trackUserSignOut();
    };
    return {
        setUserSession,
        clearUserSession,
        signOutAppState,
        loading: loader,
    };
};
exports.useAppState = useAppState;
